<div class="flex flex-column w-12 mx-0 sm:text-base text-sm">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="text-center" style="width: 95%">
        <span class="my-0 py-0 font-weight-normal"
          >Temporal Validation Result files</span
        >
      </div>
    </ng-template>
    <ng-template pTemplate="icons"> </ng-template>
    @if (
      !fileError() && !dataFetchError() && updatedMetrics$ | async;
      as metrics
    ) {
      <div
        style="min-height: 400px"
        class="flex flex-column align-content-center justify-content-center"
      >
        @if (
          selectedMetric() && selectedMetric().boxplotFiles | async;
          as boxplots
        ) {
          <div class="flex flex-column w-12 flex-wrap gap-2">
            <div
              class="flex flex-row w-12 align-content-center justify-content-center my-2 py-3 lg:flex-nowrap flex-wrap gap-2"
            >
              <div
                class="flex flex-column lg:w-6 w-10 flex-wrap justify-content-center align-content-center gap-4"
              >
                <!-- Main metric dropdown -->
                <div class="flex flex-column w-10">
                  <p-floatLabel>
                    <p-select
                      id="metricSelector"
                      (onChange)="onMetricChange($event)"
                      [options]="metrics"
                      [ngModel]="selectedMetric()"
                      optionLabel="metric_pretty_name"
                      [style]="{ width: '100%' }"
                    >
                    </p-select>
                    <label for="metricSelector"
                      >Select boxplot/map metric</label
                    >
                  </p-floatLabel>
                </div>
                <!-- Second dropdown: Group by OR Select dataset combination -->
                @if (boxplots.length > 1) {
                  <div class="flex flex-column w-10 mt-2">
                    <p-floatLabel>
                      <p-select
                        id="boxplotSelector"
                        (onChange)="onBoxPlotChange($event)"
                        [options]="selectedMetric().boxplot_dicts"
                        [ngModel]="selectedMetric().boxplot_dicts[boxplotIndx]"
                        optionLabel="name"
                        [style]="{ width: '100%' }"
                      >
                      </p-select>
                      <label for="boxplotSelector">
                        {{
                          isDatasetCombination(selectedMetric())
                            ? "Select dataset combination"
                            : "Select boxplot classification"
                        }}
                      </label>
                    </p-floatLabel>
                  </div>
                }
              </div>
              <div
                class="flex flex-row lg:w-6 w-10 lg:flex-nowrap flex-wrap justify-content-center align-content-center gap-2"
              >
                <div
                  class="flex flex-column lg:w-5 w-10 justify-content-center"
                >
                  <button
                    pButton
                    type="button"
                    icon="pi pi-download"
                    class="btn-action-large download-results"
                    label="Download graphs"
                    pTooltip="Download graphs .zip"
                    [life]="globals.tooltipLifetime"
                    (click)="
                      downloadResultFile(
                        validation.id,
                        'graphics',
                        validation.id + '_graphs.zip'
                      )
                    "
                  ></button>
                </div>
                <div
                  class="flex flex-column lg:w-5 w-10 justify-content-center"
                >
                  <button
                    pButton
                    type="button"
                    label="Download NetCDF"
                    pTooltip="Download all results in NetCDF format"
                    [life]="globals.tooltipLifetime"
                    (click)="
                      downloadResultFile(
                        validation.id,
                        'netCDF',
                        validation.output_file_name
                      )
                    "
                  >
                    <span
                      ><fa-icon [icon]="faIcons.faFileDownload"></fa-icon
                    ></span>
                  </button>
                </div>
              </div>
            </div>
            <hr class="flex w-11 pt-0 mt-0 featurette-divider" />
            <div
              class="flex flex-row w-12 justify-content-center align-content-center md:text-4xl text-2xl text-muted"
            >
              Bulk Plots
              <span
                class="pi pi-question-circle mx-2 text-xl"
                pTooltip="Plots based on results from the entire selected timespan."
                tooltipPosition="bottom"
              >
              </span>
            </div>
            <!-- Overview: uses currentOverviewFiles signal instead of selectedMetric().overviewFiles -->
            @if (currentOverviewFiles() | async; as overviewPlots) {
              <div
                class="flex flex-row lg:flex-nowrap flex-wrap w-12 align-content-center justify-content-center py-3"
              >
                <!-- Boxplot -->
                @if (boxplots.length > 0) {
                  <div
                    class="flex flex-column lg:w-5 w-10 align-items-center justify-content-center"
                  >
                    <p-galleria
                      [value]="boxplots"
                      [(visible)]="displayBoxplotGallery"
                      [(activeIndex)]="activeBoxplotIndex"
                      [circular]="true"
                      [fullScreen]="true"
                      [showItemNavigators]="boxplots.length > 1"
                      [showThumbnails]="false"
                      [baseZIndex]="100000"
                    >
                      <ng-template pTemplate="item" let-item>
                        <img
                          [src]="sanitizePlotUrl(item.plot)"
                          alt="Boxplot for {{
                            selectedMetric().metric_pretty_name
                          }}"
                          style="width: 100%; display: block"
                        />
                      </ng-template>
                    </p-galleria>
                    <img
                      width="85%"
                      height="95%"
                      style="object-fit: contain"
                      [src]="sanitizePlotUrl(boxplots[boxplotIndx].plot)"
                      (click)="showGallery(boxplotIndx, 'boxplot')"
                      [ngClass]="{
                        'result-plot': true,
                        pcol: overviewPlots.length > 4,
                      }"
                      alt="Boxplot for {{
                        selectedMetric().metric_pretty_name
                      }}"
                    />
                  </div>
                }
                <!-- Overview maps -->
                <div
                  class="flex flex-row flex-wrap lg:w-6 w-10 align-content-center justify-content-center gap-3"
                >
                  @for (plot of overviewPlots; track plot; let ind = $index) {
                    <div
                      [ngClass]="{
                        'image-container': true,
                        'w-12': overviewPlots.length === 1,
                        'w-10': overviewPlots.length === 2,
                        'w-5': overviewPlots.length > 2,
                      }"
                    >
                      <span class="image-label">
                        {{
                          isDatasetCombination(selectedMetric())
                            ? selectedMetric().boxplot_dicts[boxplotIndx]?.name
                            : selectedMetric().datasets[ind]
                        }}
                      </span>
                      <p-galleria
                        [value]="overviewPlots"
                        [(visible)]="displayOverviewGallery"
                        [(activeIndex)]="activeOverviewIndex"
                        [circular]="true"
                        [fullScreen]="true"
                        [showItemNavigators]="overviewPlots.length > 1"
                        [showThumbnails]="false"
                        [baseZIndex]="100000"
                      >
                        <ng-template pTemplate="item" let-item>
                          <img
                            [src]="sanitizePlotUrl(item.plot)"
                            alt="An Overview map for {{
                              selectedMetric().metric_pretty_name
                            }}"
                            style="width: 100%; display: block"
                          />
                        </ng-template>
                      </p-galleria>
                      <img
                        width="95%"
                        height="85%"
                        style="object-fit: contain"
                        [src]="sanitizePlotUrl(plot.plot)"
                        (click)="showGallery(ind, 'overview')"
                        [ngClass]="{ 'result-plot': true, pcol: true }"
                        alt="An Overview map for {{
                          selectedMetric().metric_pretty_name
                        }}"
                      />
                    </div>
                  }
                </div>
              </div>
            }
            <!-- Additional plots (intra-annual / stability) -->
            @if (
              validation.intra_annual_metrics || validation.stability_metrics
            ) {
              <div class="flex flex-column w-12 align-items-center">
                <hr class="flex w-11 pt-0 mt-0 featurette-divider" />
                <div
                  class="flex flex-row w-12 flex-wrap justify-content-center align-content-center md:text-4xl text-2xl text-muted"
                >
                  Additional Plots
                  <span
                    class="pi pi-question-circle mx-2 text-2xl"
                    pTooltip="Additional results based on the assessment of either intra-annual or inter-annual product performance.
                        Note: Only graphs highlighting the key findings are shown here. Further results are available for download below"
                    tooltipPosition="bottom"
                  >
                  </span>
                </div>
                @if (
                  selectedMetric().comparisonFile | async;
                  as comparisonFile
                ) {
                  <div
                    class="flex flex-row lg:flex-nowrap flex-wrap w-12 align-content-center justify-content-center mx-2 my-3 plot-spot column-gap-3 gap-3"
                  >
                    <p-galleria
                      [value]="comparisonFile"
                      [(visible)]="displayAdditionalPlotGallery"
                      [(activeIndex)]="activeAdditionalPlotIndex"
                      [circular]="true"
                      [fullScreen]="true"
                      [showThumbnails]="false"
                      [baseZIndex]="100000"
                    >
                      <ng-template pTemplate="item" let-item>
                        <img
                          [src]="sanitizePlotUrl(item.plot)"
                          alt="Boxplot for {{
                            selectedMetric().metric_pretty_name
                          }}"
                          style="width: 70%; display: block"
                        />
                      </ng-template>
                    </p-galleria>
                    <img
                      width="55%"
                      height="55%"
                      style="object-fit: contain"
                      [src]="
                        sanitizePlotUrl(
                          comparisonFile[activeAdditionalPlotIndex].plot
                        )
                      "
                      (click)="showGallery(0, 'seasonal')"
                      [ngClass]="{ 'result-plot': true }"
                      alt="Boxplot for {{
                        selectedMetric().metric_pretty_name
                      }}"
                    />
                    <div
                      class="flex flex-column text-xl px-2 text-muted justify-content-center"
                    >
                      @if (validation.intra_annual_metrics) {
                        <em>
                          Intra-Annual Metrics <br />
                          Frequency: {{ validation.intra_annual_type }} <br />
                          Overlap: {{ validation.intra_annual_overlap }} day(s)
                        </em>
                      }
                      @if (validation.stability_metrics) {
                        <em> Stability Metrics </em>
                      }
                    </div>
                  </div>
                } @else {
                  <div
                    class="flex flex-row w-12 justify-content-center align-content-center text-muted py-4 md:text-xl"
                  >
                    <em style="color: darkgrey">
                      There are no plots for the selected metric
                    </em>
                  </div>
                }
                @if (dataFetchError() || fileError()) {
                  <div>
                    <p class="lead text-muted">
                      Result plots are temporarily unavailable.
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </p-panel>

  <p-panel>
    <ng-template pTemplate="header">
      <div class="text-center" style="width: 95%">
        <span class="my-0 py-0 font-weight-normal">
          {{ showInteractiveMap ? "Click & Explore" : "Interactive Map" }}
        </span>
      </div>
    </ng-template>

    @if (showInteractiveMap === null) {
      <div class="text-center text-muted py-3">
        <i class="pi pi-spin pi-spinner"></i> Checking for interactive map...
      </div>
    }

    @if (showInteractiveMap === true) {
      <qa-interactive-map [validationId]="validation.id"></qa-interactive-map>
    }

    @if (showInteractiveMap === false) {
      <div class="text-center text-muted py-3">
        No result file for interactive map detected – legacy run.
      </div>
    }
  </p-panel>
</div>
